import api from '../../../services/api'
import { Response } from '../../../interfaces/types'
import { Friend } from '@/domain/entities/friend.entity'

export class FriendsRepository {
  token?: string

  setToken(_token?: string) {
    this.token = _token
  }

  private static Instance: FriendsRepository = null
  public static GetInstance() {
    const instance = this.Instance ? this.Instance : new FriendsRepository()
    return instance
  }

  async list(
    token: string,
    params: { page: number; perPage: number },
  ): Promise<Response<Friend>> {
    const headers = { Authorization: `Bearer ${token}` }

    const { data } = await api.get<{ friends: Response<Friend> }>('/friends', {
      headers,
      params,
    })

    return data.friends
  }
}
